export default {
  name: {
    type_id: "Type",
  },
  type: {
    1: "Hardware",
    2: "Material",
  },
};
